/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'icap-logs';
const prefix = `${moduleName}.${componentName}`;

export const gridColumnHeaderActionLabel = `${prefix}.gridColumnHeaderActionLabel`;
export const gridColumnHeaderTypeLabel = `${prefix}.gridColumnHeaderTypeLabel`;
export const gridColumnHeaderReasonLabel = `${prefix}.gridColumnHeaderReasonLabel`;
export const gridColumnHeaderViolationsLabel = `${prefix}.gridColumnHeaderViolationsLabel`;
export const gridColumnHeaderScoreLabel = `${prefix}.gridColumnHeaderScoreLabel`;

export const ENGLISH = {
    [gridColumnHeaderActionLabel]: 'Request Action',
    [gridColumnHeaderTypeLabel]: 'Type',
    [gridColumnHeaderReasonLabel]: 'Reason',
    [gridColumnHeaderViolationsLabel]: 'Violations',
    [gridColumnHeaderScoreLabel]: 'Score',
};
